import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteOrganizationAccountMutation} from '../hooks/useOrganizationAccountsQuery';
import {useOrganizationAccountsSelection} from "../hooks/useOrganizationAccountsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteOrganizationAccountMutation = useDeleteOrganizationAccountMutation();

    const {
        selection,
        handleClearSelection,
    } = useOrganizationAccountsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteOrganizationAccountMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
